import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

const DriverFilters = ({ cardsFilters, onResetFilters, setCardsFilters }) => {
  // prettier-ignore
  const handleFilterChange = filter => R.compose(
    setCardsFilters,
    R.assoc(filter),
    R.path(['target', 'value'])
  );

  return (
    <>
      <TextField
        fullWidth
        label="Driver"
        name="Driver"
        onChange={handleFilterChange('driver')}
        value={cardsFilters.driver}
      />

      <FormControl fullWidth>
        <InputLabel id="filter-status">Status</InputLabel>
        <Select
          label="Status"
          labelId="filter-status"
          onChange={handleFilterChange('status')}
          value={cardsFilters.status}
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Inactive">Inactive</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth>
        <InputLabel id="filter-expiration">Expiration</InputLabel>
        <Select
          label="Expiration"
          labelId="filter-expiration"
          onChange={handleFilterChange('expiration')}
          value={cardsFilters.expiration}
        >
          <MenuItem value="Any">Any</MenuItem>
          <MenuItem value="Valid">Valid</MenuItem>
          <MenuItem value="Expired">Expired</MenuItem>
          <MenuItem value="30 days">Expires within 30 days</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth>
        <InputLabel id="filter-capabilities">Loading Capabilities</InputLabel>
        <Select
          label="Loading Capabilities"
          labelId="filter-capabilities"
          onChange={handleFilterChange('capability')}
          value={cardsFilters.capability}
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="Load">Load</MenuItem>
          <MenuItem value="Unload">Unload</MenuItem>
        </Select>
      </FormControl>

      <Button onClick={onResetFilters} sx={{ mt: 2 }} variant="text">
        Clear
      </Button>
    </>
  );
};

DriverFilters.propTypes = {
  cardsFilters: PropTypes.shape({
    capability: PropTypes.oneOf(['All', 'Load', 'Unload']),
    driver: PropTypes.string,
    expiration: PropTypes.oneOf(['Any', 'Valid', 'Expired', '30 days']),
    status: PropTypes.oneOf(['All', 'Active', 'Inactive']),
  }).isRequired,
  onResetFilters: PropTypes.func.isRequired,
  setCardsFilters: PropTypes.func.isRequired,
};

export default DriverFilters;
